import {Component, computed, inject, signal} from '@angular/core'
import {Configuration, toColumn} from '../../../services/configuration'
import {BindingPipe, FormatNumberDirective, sortOriginal} from '@sparbanken-syd/sparbanken-syd-theme'
import {FormsModule} from '@angular/forms'
import {DecimalPipe, JsonPipe, KeyValuePipe} from '@angular/common'
import {MatFormField, MatInput, MatLabel, MatSuffix} from '@angular/material/input'
import {MatOption} from '@angular/material/core'
import {MatSelect} from '@angular/material/select'
import {LoanProductPipe} from '../../../1-components/8-pipes/loan-product/loan-product-pipe'
import {LoanProductMap} from '../../../0-application/shared'

@Component({
  selector: 'spb-simulator',
  imports: [
    BindingPipe,
    FormatNumberDirective,
    FormsModule,
    KeyValuePipe,
    MatFormField,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    MatSuffix,
    DecimalPipe,
    LoanProductPipe,
    JsonPipe
  ],
  templateUrl: './simulator.html',
  // Use "table inputs" to align our inputs
  styleUrls: ['../../../1-components/table-inputs.scss', './simulator.scss']
})
export class Simulator {
  public product = signal<string>('l753')
  public binding = signal<number>(3)
  public ltv = signal<number>(68)
  public ltvColumn = computed(() => this.service.ltvColumn(this.ltv()))


  public internalEmulatedInterest = computed(() => {
    return this.service.internalInterest(this.product(), this.binding(), this.ltv())
  })

  public emulatorValues = computed(() => {

    const column = this.service.ltvColumn(this.ltv())
    // The discount column is the same as the row... by chance?
    const col = [toColumn[this.binding()]][0]
    const row = [...this.service.productionPrices()].findIndex(r => r.product === this.binding())
    return {
      column: this.service.ltvColumn(this.ltv()),
      // The row in the production price table.
      row,
      // The discount column is the same as the row... by chance?
      discountColumn: col,
      discount: this.service.bindingDiscounts()[0][col](),
      productionPrice: [...this.service.productionPrices()]
        .find(r => r.product === this.binding())?.interests[column](),
      maxLtv: [...this.service.productionPrices()]
        .find(r => r.product === this.binding())?.interests[100]()
    }
  })
  private readonly service = inject(Configuration)
  protected readonly LoanProductMap = LoanProductMap
  protected readonly sortOriginal = sortOriginal
}
